module.exports = __webpack_public_path__ + "img/pos-icon-dark.2053cb94.svg";